// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"471":"c09bf4bf","777":"f677bbe4","803":"f9c54855"}[chunkId] + ".chunk.css";
};